import styles from './navbar.module.css';
import { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import CustomSearchBar from './CustomSearchBar';

export default function Navbar() {
  const location = useLocation();
  const isSearchPage = location.pathname === '/search';

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cse.google.com/cse.js?cx=17ab97e79478a4154";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <nav className={styles.navbarContent}>
      {/* Dual logo section */}
      <div className={styles.logoContainer}>
        {/* Google logo */}
        <a href="/" className={styles.logoSection}>
          <img
            className={styles.logo}
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/768px-Google_%22G%22_logo.svg.png"
            alt="Google Logo"
          />
          <span className={styles.siteName}>Google</span>
        </a>

         {/* Grey separator line */}
        <div className={styles.logoSeparator}></div>


        {/* ProductSpace logo */}
        <a href="/" className={styles.productSpaceSection}>
          <img
            className={styles.productSpaceLogo}
            src="/ProductSpaceLogo+GU.png"
            alt="ProductSpace @ Georgetown University"
          />
        </a>
      </div>

      {/* Google CSE search box - hidden on search page */}
      {!isSearchPage && <CustomSearchBar />}
    </nav>
  );
}
